<template>
    <div class="container main py-4">
        <div class="container info_bar py-3 ">
            <div class="learn">
                <div>Currently practicing: <span>Vue</span></div>
                <div>Learning next: <span >Wordpress</span></div>
            </div>

            <b-nav class="nav-scroll" pills  v-b-scrollspy:nav-scroller >
                <b-nav-item pills v-for="(item, i) in skillsData" :key="i" :href="`#${item.id}`" @click="scrollIntoView">{{item.skillType}}</b-nav-item>
            </b-nav>
        </div>


        <div class="container skills_content pt-4" id="nav-scroller" ref="content">
            <section class="skill_type" v-for="(obj, i) in skillsData" :key="i" :id="obj.id">
                <h2>{{obj.skillType}}</h2>
                <div class="skills row">
                    <div class="skill col-lg col-md-6 col-xs-12" v-for="(item, j) in obj.skillData" :key="j">
                        <h3 v-for="(skill, k) in item.skill" :key="k">{{skill}}</h3>
                        <ul class="subSkills">
                            <li v-for="(param, l) in item.subSkills" :key="l">{{param}}</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Skills",
        methods: {
            // Convenience method to scroll a heading into view.
            // Not required for scrollspy to work
            scrollIntoView(e) {
                e.preventDefault();
                const href = e.target.getAttribute('href');
                const el = href ? document.querySelector(href) : null;
                if (el) {
                    this.$refs.content.scrollTop = el.offsetTop
                }
            }
        },
        data() {
            return {
                skillsData: [
                    {
                        skillType: "Coding skills",
                        id: "coding_skills",
                        hrefTarget: "#coding_skills",
                        skillData: [
                            {
                                skill: ["Javascript"],
                                subSkills: ["ES6", "jQuery", "React", "Vue"]
                            }
                        ]
                    },
                    {
                        skillType: "Design skills",
                        id: "design_skills",
                        hrefTarget: "#design_skills",
                        skillData: [
                            {
                                skill: ["HTML5"],
                                subSkills: ["Pug", "Slim"]
                            },
                            {
                                skill: ["CSS3"],
                                subSkills: ["SASS", "Stylus"]
                            },
                            {
                                skill: ["Editing"],
                                subSkills: ["Photoshop", "Photopea"]
                            }
                        ]
                    },
                    {
                        skillType: "IT skills",
                        id: "IT_skills",
                        hrefTarget: "#IT_skills",
                        skillData: [
                            {
                                skill: ["Tools"],
                                subSkills: ["Git", "NPM", "Webpack", "REST API"]
                            },
                            {
                                skill: ["Optimization"],
                                subSkills: ["SEO","RWD", "Bootstrap 4"]
                            },
                            {
                                skill: ["Testing"],
                                subSkills: ["Lighthouse", "Jest"]
                            },
                        ]
                    },
                    {
                        skillType: "General skills",
                        id: "general_skills",
                        hrefTarget: "#general_skills",
                        skillData: [
                            {
                                skill: ["General"],
                                subSkills: ['Critical thinking', "Research", "Creative Writing"]
                            },
                            {
                                skill: ["Languages"],
                                subSkills: ["Romanian", "English", "Japanese"]
                            }
                        ]
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .main{
        height: auto;
        position: relative;
    }
    .nav-item {
        display: flex !important;
        padding: 0;
        width: auto;
    }
    .info_bar {
        height: auto;
        position: sticky;
        top: 0;
        left: 0;
        z-index: 90;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: linear-gradient(to top, #3f2b90, #a8c0ff);

    }
    .learn {
        width: 100%;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        color: black;
        text-shadow: 0 0 5px blue;
        font-weight: 600;
    }
    .learn > div > span {
        text-decoration: underline;
    }
    #nav-scroller {
        position: relative;
        height: 100vh;
        overflow-y: scroll;
    }
    #nav-scroller::-webkit-scrollbar {
        display: none;
    }
    /*FIND A WAY TO NOT NEED OVERFLOW-Y: scroll ON nav*/
    .skill_type {
        height: auto;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
    }
    h2 {
        color: white;
        font-weight: 700;
        text-shadow: 0 0 8px blue;
        padding: 100px 0;
    }

    .skills {
        display: flex;
        width: 100%;
        justify-content: center;

    }

    .skill {
        display: flex;
        flex-direction: column;
        max-width: 400px;


    }
    h3 {
        background: linear-gradient(to top, #24243e, #302b63, #0f0c29);
        padding: 20px;
        position: absolute;
        z-index: 3;
        top: -40px;
        left: -10px;
        box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
        color: white;
        text-shadow: 0 0 15px blue;
    }
    .subSkills {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        padding: 50px 40px 40px 40px;
        list-style: none;
        box-shadow: 0 0 24px 0 rgba(255,255,255,1);
        height: 100%;
        background: linear-gradient(to bottom, #FFFFFF, #6DD5FA, #2980B9);
        border-radius: 15px;

    }
    li {

        padding: 5px 0 5px 25px;
        margin: 3px 0;
        color: black;
        text-shadow: 0 0 2px blue;
        font-weight: 700;

    }
</style>